<template>
    <div>
        <div class="vx-row">
            <div class="vx-col w-full xl:w-1/3 lg:w-1/2 md:w-1/2" >
                <vx-card :title="$t('Data')" class="mb-base" id="page-user-view" v-if="this.projectOffer">
                    <table>
                        <tr>
                            <td class="font-semibold">{{$t("Name")}}</td>
                            <td>{{ projectOffer.name }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("Client")}}</td>
                            <td>{{ $store.getters.companyClients[projectOffer.client_company_id].name }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("User")}}</td>
                            <td>{{ $store.getters.companyUsers[projectOffer.company_user_id].name }}</td>
                        </tr>
                    </table>
                    <h6 class="mt-6">{{$t("Description")}}</h6>
                    <p style="white-space: pre-wrap" class="mt-3">{{ projectOffer.description }}</p>

                    <vs-divider/>
                    <vs-button v-if="this.projectOffer.company_user_id === $store.state.userData.id || this.$checkPermission(210)" class="mt-5 mr-3" style="float: left" color="warning" icon-pack="feather" icon="icon-edit" type="border" @click="editProjectOfferPrompt = true" >{{$t("Edit")}}</vs-button>
                    <vs-button v-if="this.projectOffer.company_user_id === $store.state.userData.id || this.$checkPermission(210)" class="mt-5 mr-3" style="float: left" color="success" icon-pack="feather" icon="icon-plus-circle" type="border" @click="createProjectFromOffer" >{{$t("CreateProjectFromOffer")}}</vs-button>
                    <div style="clear: both"/>

                    <vs-popup :title="$t('Edit')" :active.sync="editProjectOfferPrompt" v-if="projectOfferEdit">
                        <div>
                            <p class="mt-6">{{$t("Name")}}</p>
                            <vs-input v-model="projectOfferEdit['name']" style="width: 100%"></vs-input>
                            <p class="mt-6">{{$t("AssignedUser")}}</p>
                            <vs-select autocomplete style="width: 100%" class="selectExample" v-model="projectOfferEdit['company_user_id']">
                                <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in this.$store.getters.companyUsers" />
                            </vs-select>
                            <p class="mt-6">{{$t("Description")}}</p>
                            <vs-textarea v-model="projectOfferEdit['description']" class="w-full" />
                            <vs-divider/>
                            <vs-divider/>
                            <vs-button style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="editProjectOffer">{{$t("Change")}}</vs-button>
                            <vs-button style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeProjectOffer">{{$t("Delete")}}</vs-button>
                        </div>
                    </vs-popup>

                </vx-card>
            </div>
            <div class="vx-col w-full xl:w-2/3 lg:w-1/2 md:w-1/2">
                <project-files-table :id="Number(this.$route.params.id)" :editable="this.$checkPermission(210)" :type="1"/>
            </div>
        </div>

        <vx-card :title='$t("ProjectOfferTasks")' v-if="projectOfferTasks">
            <vs-table ref="table" v-model="selected" @selected="handleSelected" pagination :max-items="50" search :data="projectOfferTasks">

                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <div class="flex flex-wrap-reverse items-center">
                        <vs-button v-if="this.projectOffer.company_user_id === $store.state.userData.id || this.$checkPermission(210)" type="border" color="success" icon-pack="feather" icon="icon-plus-circle" @click="addProjectOfferTaskPrompt = true">{{$t("Add")}}</vs-button>
                    </div>

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ projectOfferTasks.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : projectOfferTasks.length }} of {{ projectOfferTasks.length }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th sort-key="title">{{$t("TaskTitle")}}</vs-th>
                    <vs-th sort-key="description">{{$t("Description")}}</vs-th>
                    <vs-th sort-key="hours">{{$t("HourNumber")}}</vs-th>
                    <vs-th sort-key="deadline_days">{{$t("DeadlineFromStart")}}</vs-th>
                    <vs-th sort-key="branch_office_id">{{$t("BranchOffice")}}</vs-th>
                </template>

                <template slot-scope="{data}">
                    <tbody>
                    <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                        <vs-td :data="data[index].title">
                            {{ data[index].title }}
                        </vs-td>

                        <vs-td :data="data[index].description">
                            {{ data[index].description }}
                        </vs-td>

                        <vs-td :data="data[index].hours">
                            {{ data[index].hours }}
                        </vs-td>

                        <vs-td :data="data[index].deadline_days">
                            {{ data[index].deadline_days }}
                        </vs-td>

                        <vs-td v-if="branchOffices" :data="data[index].branch_office_id">
                            {{ branchOffices[data[index].branch_office_id].title }}
                        </vs-td>

                    </vs-tr>
                    </tbody>
                </template>

            </vs-table>

            <vs-popup :title="$t('Add')" :active.sync="addProjectOfferTaskPrompt">
                <div>
                    <p class="mt-6">{{$t("TaskTitle")}}</p>
                    <vs-input v-model="projectOfferTaskAdding['title']" style="width: 100%"></vs-input>
                    <p class="mt-6">{{$t("HourNumber")}}</p>
                    <vs-input v-model="projectOfferTaskAdding['hours']" style="width: 100%"></vs-input>
                    <p class="mt-6">{{$t("DeadlineFromStart")}}</p>
                    <vs-input v-model="projectOfferTaskAdding['deadline_days']" style="width: 100%"></vs-input>
                    <p class="mt-6">{{$t("BranchOffice")}}</p>
                    <vs-select autocomplete style="width: 100%" class="selectExample" v-model="projectOfferTaskAdding['branch_office_id']">
                        <vs-select-item :key="index" :value="item.id" :text="item.title" v-for="(item,index) in this.branchOffices" />
                    </vs-select>
                    <p class="mt-6">{{$t("Description")}}</p>
                    <vs-textarea v-model="projectOfferTaskAdding['description']" class="w-full" />
                    <vs-divider/>
                    <vs-button color="success" type="border" class="mt-6; mr-1" @click="addProjectOfferTask">{{$t("Add")}}</vs-button>
                </div>
            </vs-popup>

            <vs-popup :title="$t('Edit')" :active.sync="editProjectOfferTaskPrompt">
                <div>
                    <p class="mt-6">{{$t("TaskTitle")}}</p>
                    <vs-input v-model="projectOfferTaskEdit['title']" style="width: 100%"></vs-input>
                    <p class="mt-6">{{$t("HourNumber")}}</p>
                    <vs-input v-model="projectOfferTaskEdit['hours']" style="width: 100%"></vs-input>
                    <p class="mt-6">{{$t("DeadlineFromStart")}}</p>
                    <vs-input v-model="projectOfferTaskEdit['deadline_days']" style="width: 100%"></vs-input>
                    <p class="mt-6">{{$t("BranchOffice")}}</p>
                    <vs-select autocomplete style="width: 100%" class="selectExample" v-model="projectOfferTaskEdit['branch_office_id']">
                        <vs-select-item :key="index" :value="item.id" :text="item.title" v-for="(item,index) in this.branchOffices" />
                    </vs-select>
                    <p class="mt-6">{{$t("Description")}}</p>
                    <vs-textarea v-model="projectOfferTaskEdit['description']" class="w-full" />
                    <vs-divider/>
                    <vs-button v-if="this.projectOffer.company_user_id === $store.state.userData.id || this.$checkPermission(210)" style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="editProjectOfferTask">{{$t("Change")}}</vs-button>
                    <vs-button v-if="this.projectOffer.company_user_id === $store.state.userData.id || this.$checkPermission(210)" style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeProjectOfferTask">{{$t("Delete")}}</vs-button>
                </div>
            </vs-popup>
        </vx-card>

    </div>
</template>
<script>

    import ProjectFilesTable from "./ProjectFilesTable";
    export default {
        components: {ProjectFilesTable},
        data() {
            return {
                selected: {},
                projectOfferTasks: undefined,

                projectOffer: undefined,
                projectOfferEdit: {},

                itemsPerPage: 20,
                isMounted: false,

                addProjectOfferTaskPrompt: false,
                editProjectOfferTaskPrompt: false,
                editProjectOfferPrompt: false,

                projectOfferTaskAdding: {},
                projectOfferTaskEdit: {},

                branchOfficesRaw: [],

            }
        },
        computed: {
            currentPage() {
                if(this.isMounted) {
                    return 1
                    return this.$refs.table.currentx
                }
                return 0
            },
            branchOffices() {

                if(!this.branchOfficesRaw) return undefined;

                let list = {};
                for(let x = 0; x < this.branchOfficesRaw.length; x++) {
                    list[this.branchOfficesRaw[x].id] = this.branchOfficesRaw[x];
                }

                return list;

            }
        },
        methods: {
            handleSelected(tr) {
                this.projectOfferTaskEdit = JSON.parse(JSON.stringify(tr));
                this.editProjectOfferTaskPrompt = true;
            },
            updateProjectOffer(){
                const thisIns = this;
                this.$http.get('/api/v1/projectOffer/' + this.$route.params.id)
                    .then(function (response) {
                        thisIns.projectOffer = response.data;
                        thisIns.projectOfferEdit = JSON.parse(JSON.stringify(thisIns.projectOffer));

                        thisIns.$http.get('/api/v1/client/' + thisIns.projectOffer.client_company_id + '/branch_offices')
                            .then(function (response) {
                                thisIns.branchOfficesRaw = response.data;
                                thisIns.projectOfferTaskAdding['branch_office_id'] = thisIns.branchOfficesRaw[0].id
                            })
                            .catch(function (error) {
                                thisIns.$vs.notify({
                                    title:'Error',
                                    position:'top-right',
                                    text: error,
                                    color:'danger',
                                    iconPack: 'feather',
                                    icon:'icon-alert-circle'})
                            });

                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            updateProjectOfferTasks() {
                const thisIns = this;
                this.$http.get('/api/v1/projectOffer/' + this.$route.params.id + "/task")
                    .then(function (response) {
                        thisIns.projectOfferTasks = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            addProjectOfferTask() {
                const thisIns = this;
                this.$http.post('/api/v1/projectOffer/' + this.$route.params.id + "/task", {
                    title: this.projectOfferTaskAdding.title,
                    description: this.projectOfferTaskAdding.description,
                    hours: Number(this.projectOfferTaskAdding.hours),
                    deadline_days: Number(this.projectOfferTaskAdding.deadline_days),
                    branch_office_id : Number(this.projectOfferTaskAdding.branch_office_id)
                }).then(function () {
                        thisIns.addProjectOfferTaskPrompt = false;
                        thisIns.updateProjectOfferTasks();
                        thisIns.projectOfferTaskAdding = {}
                    }).catch(function (error) {
                    thisIns.addProjectOfferTaskPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            editProjectOfferTask(){
                const thisIns = this;
                this.$http.put('/api/v1/projectOffer/' + this.$route.params.id + "/task/" + this.selected.id, {
                    title: this.projectOfferTaskEdit.title,
                    description: this.projectOfferTaskEdit.description,
                    hours: Number(this.projectOfferTaskEdit.hours),
                    deadline_days: Number(this.projectOfferTaskEdit.deadline_days),
                    branch_office_id : Number(this.projectOfferTaskEdit.branch_office_id)
                }).then(function () {
                    thisIns.updateProjectOfferTasks();
                    thisIns.editProjectOfferTaskPrompt = false;
                }).catch(function (error) {
                    thisIns.editProjectOfferTaskPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            removeProjectOfferTask(){
                const thisIns = this;
                this.$http.delete('/api/v1/projectOffer/' + this.$route.params.id + "/task/" + this.selected.id)
                    .then(function () {
                        thisIns.updateProjectOfferTasks();
                        thisIns.editProjectOfferTaskPrompt = false;
                    }).catch(function (error) {
                    thisIns.editProjectOfferTaskPrompt = false;
                    thisIns.$vs.notify({
                        title: 'Error',
                        text: error,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                });
            },
            editProjectOffer(){
                const thisIns = this;
                this.$http.put('/api/v1/projectOffer/' + this.$route.params.id, this.projectOfferEdit)
                .then(function () {
                    thisIns.updateProjectOffer();
                    thisIns.editProjectOfferPrompt = false;
                }).catch(function (error) {
                    thisIns.editProjectOfferPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            removeProjectOffer(){
                const thisIns = this;
                this.$http.delete('/api/v1/projectOffer/' + this.$route.params.id)
                    .then(function () {
                        thisIns.editProjectOfferPrompt = false;
                        thisIns.$nextTick(() => {
                            thisIns.$router.push('/projectOffers')
                        });
                    }).catch(function (error) {
                    thisIns.editProjectOfferPrompt = false;
                    thisIns.$vs.notify({
                        title: 'Error',
                        text: error,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                });
            },
            createProjectFromOffer(){
                const thisIns = this;
                this.$http.get('/api/v1/projectOffer/' + this.$route.params.id + '/project')
                    .then(function (response) {
                        thisIns.$router.push('/project/' + response.data)
                    }).catch(function (error) {
                    thisIns.$vs.notify({
                        title: 'Error',
                        text: error,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                });
            },
        },
        watch: {
            editProjectOfferTaskPrompt: function () {
                if(!this.editProjectOfferTaskPrompt){
                    this.selected = {}
                }
            }
        },
        created() {
            this.updateProjectOffer();
            this.updateProjectOfferTasks();
        },
        mounted() {
            this.isMounted = true;
        },
        beforeRouteLeave (to, from, next) {
            if(this.addProjectOfferTaskPrompt){
                this.addProjectOfferTaskPrompt = false;
                next(false)
            }else if(this.editProjectOfferTaskPrompt){
                this.editProjectOfferTaskPrompt = false;
                next(false)
            }else if(this.saveOfferAsTemplatePrompt){
                this.saveOfferAsTemplatePrompt = false;
                next(false)
            }else{
                next()
            }
        }
    }
</script>
<style lang="scss">
    #page-user-view {
        table {
            td {
                vertical-align: top;
                min-width: 140px;
                padding-bottom: .8rem;
                word-break: break-all;
            }

            &:not(.permissions-table) {
                td {
                    @media screen and (max-width:370px) {
                        display: block;
                    }
                }
            }
        }
    }

    @media screen and (min-width:1201px) and (max-width:1211px),
    only screen and (min-width:636px) and (max-width:991px) {
        #account-info-col-1 {
            width: calc(100% - 12rem) !important;
        }

    }
</style>
